import { Injectable } from '@angular/core';
import { Product, ProductIngredient } from './cart.model';
import { Subject } from 'rxjs/internal/Subject';

@Injectable({
  providedIn: 'root',
})
export class CartService {
  cart: Product[] = [];
  private totalElements = new Subject<number>();
  totalElements$ = this.totalElements.asObservable();
  private subtotal = new Subject<number>();
  subtotal$ = this.subtotal.asObservable();

  // productList = [
  //   {
  //     productId: 1,
  //     productType: 1,
  //     name: 'MARGARITA',
  //     price: 9.5,
  //     extraPrice: 0,
  //     description: 'Salsa de tomate y Muzzarella',
  //     ingredients: [],
  //     finalIngredients: [],
  //     finalIngredientsName: [],
  //     image_url: 'assets/img/pizzas/Pizza.Piola.001-shadow@400w.png',
  //     quantity: 1,
  //   },
  //   {
  //     productId: 2,
  //     productType: 1,
  //     name: 'SALAMI',
  //     price: 9.5,
  //     extraPrice: 0,
  //     description: 'Salsa de tomate, Muzzarella y Salami',
  //     ingredients: [1],
  //     finalIngredients: [1],
  //     finalIngredientsName: [],
  //     image_url: 'assets/img/pizzas/peperoni.webp',
  //     quantity: 1,
  //   },
  //   {
  //     productId: 3,
  //     productType: 1,
  //     name: 'CHAMPI',
  //     price: 9.5,
  //     extraPrice: 0,
  //     description: 'Salsa de tomate, Muzzarella, Jamon York y Champignones',
  //     ingredients: [2, 3],
  //     finalIngredients: [2, 3],
  //     finalIngredientsName: [],
  //     image_url: 'assets/img/pizzas/champi.webp',
  //     quantity: 1,
  //   },
  //   {
  //     productId: 4,
  //     productType: 1,
  //     name: 'HAWAI',
  //     price: 9.5,
  //     extraPrice: 0,
  //     description: 'Salsa de tomate, Jamón York y Piña',
  //     ingredients: [2, 4],
  //     finalIngredients: [2, 4],
  //     finalIngredientsName: [],
  //     image_url: 'assets/img/pizzas/Pizza.Piola.014-shadow@400w.png',
  //     quantity: 1,
  //   },
  //   {
  //     productId: 5,
  //     productType: 1,
  //     name: '4 QUESOS',
  //     price: 9.5,
  //     extraPrice: 0,
  //     description: 'Muzzarella, Ricotta, Pecorino y Gorgonzola',
  //     ingredients: [],
  //     finalIngredients: [],
  //     finalIngredientsName: [],
  //     image_url: 'assets/img/pizzas/Pizza.Piola.004-shadow@400w.png',
  //     quantity: 1,
  //   },
  //   {
  //     productId: 6,
  //     productType: 1,
  //     name: 'Atún',
  //     price: 9.5,
  //     extraPrice: 0,
  //     description: 'Salsa de tomate, Muzzarella y Atún',
  //     ingredients: [6],
  //     finalIngredients: [6],
  //     finalIngredientsName: [],
  //     image_url: 'assets/img/pizzas/margarita.webp',
  //     quantity: 1,
  //   },
  //   {
  //     productId: 7,
  //     productType: 1,
  //     name: 'CAPRICCIOSA',
  //     price: 9.5,
  //     extraPrice: 0,
  //     description: 'Salsa de tomate , Alcachofas y Champignones ',
  //     ingredients: [3, 6],
  //     finalIngredients: [3, 6],
  //     finalIngredientsName: [],
  //     image_url: 'assets/img/pizzas/capricciosa.webp',
  //     quantity: 1,
  //   },
  //   {
  //     productId: 7,
  //     productType: 1,
  //     name: 'DIAVOLA',
  //     price: 9.5,
  //     extraPrice: 0,
  //     description: 'Salsa de tomate , Salami y Pimientos picantes',
  //     ingredients: [1, 7],
  //     finalIngredients: [1, 7],
  //     finalIngredientsName: [],
  //     image_url: 'assets/img/pizzas/diavola.webp',
  //     quantity: 1,
  //   },
  //   // SALADS
  //   {
  //     productId: 8,
  //     productType: 2,
  //     name: 'TONNO',
  //     price: 7.5,
  //     extraPrice: 0,
  //     description: 'Lechuga, tomate, cebolla, atún',
  //     ingredients: [],
  //     finalIngredients: [],
  //     finalIngredientsName: [],
  //     image_url: 'assets/img/salads/tonno.webp',
  //     quantity: 1,
  //   },
  //   {
  //     productId: 9,
  //     productType: 2,
  //     name: 'CAPRESE',
  //     price: 7.5,
  //     extraPrice: 0,
  //     description: 'Tomate, muzzarella, albahaca',
  //     ingredients: [],
  //     finalIngredients: [],
  //     finalIngredientsName: [],
  //     image_url: 'assets/img/salads/caprese.webp',
  //     quantity: 1,
  //   },
  //   {
  //     productId: 9,
  //     productType: 2,
  //     name: 'MIXTA',
  //     price: 5.75,
  //     extraPrice: 0,
  //     description: 'Lechuga, tomate, cebolla',
  //     ingredients: [],
  //     finalIngredients: [],
  //     finalIngredientsName: [],
  //     image_url: 'assets/img/salads/chef.webp',
  //     quantity: 1,
  //   },
  //   {
  //     productId: 10,
  //     productType: 2,
  //     name: 'CHEF',
  //     price: 7.5,
  //     extraPrice: 0,
  //     description: 'Lechuga, tomate, cebolla, aceitunas, jamón, queso',
  //     ingredients: [],
  //     finalIngredients: [],
  //     finalIngredientsName: [],
  //     image_url: 'assets/img/salads/chef.webp',
  //     quantity: 1,
  //   },
  //   {
  //     productId: 11,
  //     productType: 2,
  //     name: 'CALIFORNIA',
  //     price: 10.5,
  //     extraPrice: 0,
  //     description: 'Con pechuga de pollo, curry, salsa rosa',
  //     ingredients: [],
  //     finalIngredients: [],
  //     finalIngredientsName: [],
  //     image_url: 'assets/img/salads/chef.webp',
  //     quantity: 1,
  //   },
  //   // DRINKS
  //   {
  //     productId: 12,
  //     productType: 3,
  //     name: 'PEPSI',
  //     price: 2.5,
  //     extraPrice: 0,
  //     description: '',
  //     ingredients: [],
  //     finalIngredients: [],
  //     finalIngredientsName: [],
  //     image_url: 'https://www.dominospizza.es/images/Pepsi_148005_0_ES.png',
  //     quantity: 1,
  //   },
  //   {
  //     productId: 13,
  //     productType: 3,
  //     name: 'PEPSI MAX',
  //     price: 2.5,
  //     extraPrice: 0,
  //     description: '',
  //     ingredients: [],
  //     finalIngredients: [],
  //     finalIngredientsName: [],
  //     image_url: 'https://www.dominospizza.es/images/PepsiMax_262005_0_ES.png',
  //     quantity: 1,
  //   },
  //   {
  //     productId: 14,
  //     productType: 3,
  //     name: 'PEPSI MAX ZERO',
  //     price: 2.5,
  //     extraPrice: 0,
  //     description: '',
  //     ingredients: [],
  //     finalIngredients: [],
  //     finalIngredientsName: [],
  //     image_url:
  //       'https://www.dominospizza.es/images/PepsiMaxZero_315005_0_ES.png',
  //     quantity: 1,
  //   },
  //   {
  //     productId: 15,
  //     productType: 3,
  //     name: 'KAS Naranja',
  //     price: 2.5,
  //     extraPrice: 0,
  //     description: '',
  //     ingredients: [],
  //     finalIngredients: [],
  //     finalIngredientsName: [],
  //     image_url:
  //       'https://www.dominospizza.es/images/KasNaranja_150005_0_ES.png',
  //     quantity: 1,
  //   },
  //   {
  //     productId: 16,
  //     productType: 3,
  //     name: 'KAS Limón',
  //     price: 2.5,
  //     extraPrice: 0,
  //     description: '',
  //     ingredients: [],
  //     finalIngredients: [],
  //     finalIngredientsName: [],
  //     image_url: 'https://www.dominospizza.es/images/KasLimon_151005_0_ES.png',
  //     quantity: 1,
  //   },
  //   {
  //     productId: 17,
  //     productType: 3,
  //     name: 'Agua',
  //     price: 2.5,
  //     extraPrice: 0,
  //     description: '',
  //     ingredients: [],
  //     finalIngredients: [],
  //     finalIngredientsName: [],
  //     image_url:
  //       'https://www.dominospizza.es/images/AguaSingas_154005_0_ES.png',
  //     quantity: 1,
  //   },
  // ];

  comboList = [
    {
      comboId: 1,
      products: [1, 3, 14, 14],
      name: 'Pizza Party',
      price: 20,
      extraPrice: 0,
      description: '1 Pizza Hawai + 1 Pizza Salami + 2 Pepsi Max',
      ingredients: [],
      finalIngredients: [],
      image_url: 'assets/img/combos/combo1.webp',
      quantity: 1,
    },
  ];

  ingredientsList: ProductIngredient[] = [
    {
      productIngredientId: 1,
      name: 'Salami',
      price: 1.0,
      totalPrice: 0,
      image_url: 'assets/img/ingredients/peperoni.webp',
      initialQuantity: 0,
    },
    {
      productIngredientId: 2,
      name: 'Jamon York',
      price: 1.0,
      totalPrice: 0,
      image_url: 'assets/img/ingredients/jamon.webp',
      initialQuantity: 0,
    },
    {
      productIngredientId: 3,
      name: 'Champignones',
      price: 1.0,
      totalPrice: 0,
      image_url: 'assets/img/ingredients/champinon.webp',
      initialQuantity: 0,
    },
    {
      productIngredientId: 4,
      name: 'Piña',
      price: 1.0,
      totalPrice: 0,
      image_url: 'assets/img/ingredients/pina.webp',
      initialQuantity: 0,
    },
    {
      productIngredientId: 5,
      name: 'Atún',
      price: 1.0,
      totalPrice: 0,
      image_url: 'assets/img/ingredients/atun.webp',
      initialQuantity: 0,
    },
    {
      productIngredientId: 6,
      name: 'Alcachofas',
      price: 1.0,
      totalPrice: 0,
      image_url: 'assets/img/ingredients/alcachofa.webp',
      initialQuantity: 0,
    },
    {
      productIngredientId: 7,
      name: 'Pimiento pìcante',
      price: 1.0,
      totalPrice: 0,
      image_url: 'assets/img/ingredients/pimiento.webp',
      initialQuantity: 0,
    },
    // SALADS
    // {
    //   productIngredientId: 8,
    //   name: 'Lechuga',
    //   price: 0.5,
    //   totalPrice: 0,
    //   image_url: 'assets/img/ingredients/pimiento.webp',
    //   initialQuantity: 0,
    // },
    // {
    //   productIngredientId: 9,
    //   name: 'Tomate',
    //   price: 0.5,
    //   totalPrice: 0,
    //   image_url: 'assets/img/ingredients/pimiento.webp',
    //   initialQuantity: 0,
    // },
    // {
    //   productIngredientId: 10,
    //   name: 'Cebolla',
    //   price: 0.5,
    //   totalPrice: 0,
    //   image_url: 'assets/img/ingredients/pimiento.webp',
    //   initialQuantity: 0,
    // },
    // {
    //   productIngredientId: 11,
    //   name: 'Atún',
    //   price: 0.5,
    //   totalPrice: 0,
    //   image_url: 'assets/img/ingredients/pimiento.webp',
    //   initialQuantity: 0,
    // },
    // {
    //   productIngredientId: 12,
    //   name: 'Muzzarella',
    //   price: 0.5,
    //   totalPrice: 0,
    //   image_url: 'assets/img/ingredients/pimiento.webp',
    //   initialQuantity: 0,
    // },
    // {
    //   productIngredientId: 13,
    //   name: 'Albahaca',
    //   price: 0.5,
    //   totalPrice: 0,
    //   image_url: 'assets/img/ingredients/pimiento.webp',
    //   initialQuantity: 0,
    // },
    // {
    //   productIngredientId: 14,
    //   name: 'Aceitunas verdes',
    //   price: 0.5,
    //   totalPrice: 0,
    //   image_url: 'assets/img/ingredients/pimiento.webp',
    //   initialQuantity: 0,
    // },
    // {
    //   productIngredientId: 15,
    //   name: 'Jamón',
    //   price: 0.5,
    //   totalPrice: 0,
    //   image_url: 'assets/img/ingredients/pimiento.webp',
    //   initialQuantity: 0,
    // },
    // {
    //   productIngredientId: 16,
    //   name: 'Queso',
    //   price: 0.5,
    //   totalPrice: 0,
    //   image_url: 'assets/img/ingredients/pimiento.webp',
    //   initialQuantity: 0,
    // },
    // {
    //   productIngredientId: 17,
    //   name: 'Pechuga de pollo',
    //   price: 0.5,
    //   totalPrice: 0,
    //   image_url: 'assets/img/ingredients/pimiento.webp',
    //   initialQuantity: 0,
    // },
    // {
    //   productIngredientId: 18,
    //   name: 'Curry',
    //   price: 0.5,
    //   totalPrice: 0,
    //   image_url: 'assets/img/ingredients/pimiento.webp',
    //   initialQuantity: 0,
    // },
    // {
    //   productIngredientId: 19,
    //   name: 'Salsa rosa',
    //   price: 0.5,
    //   totalPrice: 0,
    //   image_url: 'assets/img/ingredients/pimiento.webp',
    //   initialQuantity: 0,
    // },
  ];

  constructor() {
    const storage: string | null = localStorage.getItem('cart');
    if (storage) {
      this.cart = JSON.parse(storage);
      this.setTotalElements();
      this.calculateSubtotalAmount();
    }
  }

  addProduct(product: Product, quantity: number) {
    const newProduct: Product = product;
    console.log('addProduct', quantity, newProduct);
    this.cart.push(newProduct);
    this.updateStorage();
  }

  removeProduct(index: number) {
    this.cart = this.cart.filter((product, cartIndex) => cartIndex != index);
    this.updateStorage();
  }

  changeProductQuantity(index: number, value: number) {
    this.cart = this.cart.map((product, cartIndex) => {
      const currentProduct: Product = { ...product };
      if (cartIndex === index) {
        currentProduct.quantity = value;
      }
      return currentProduct;
    });

    this.updateStorage();
  }

  updateStorage() {
    localStorage.setItem('cart', JSON.stringify(this.cart));
    this.setTotalElements();
    this.calculateSubtotalAmount();
  }

  emptyCart() {
    this.cart = [];
    this.updateStorage();
  }

  setTotalElements() {
    let totalElements = 0;
    this.cart.forEach(element => {
      totalElements += element.quantity;
    });
    this.totalElements.next(totalElements);
    return totalElements;
  }

  calculateSubtotalAmount() {
    let subtotal = 0;
    this.cart.forEach(element => {
      subtotal += Number(element.quantity) * Number(element.price || 0);
    });

    this.subtotal.next(subtotal);
    return subtotal;
  }
}
